module.exports = __webpack_public_path__ + "static/schedule-43a5f97521ec214e36acafa54997f6af.svg";